
<div>
  <div class="page-container">
    <div class="container-fluid">
      <!--<div> <nbc-alert></nbc-alert></div>-->
      <div class="row">
        <div class="col-md-12">
          <div class="header-bar clearfix">
            <!--ng-hide ng-show is replaced by *ngIf  *ngIf="editMode"-->
            <div *ngIf="displayMode">
              <p class="heading-title pull-left" *ngIf="name !== ''">
                {{name}}
                <label class="label " [ngClass]="{'label-success':activeStatus, 'label-danger':!activeStatus}"><span *ngIf="activeStatus">Active</span>
                <span *ngIf="!activeStatus">Inactive</span></label>
                
                <button type="button" class="btn-icon-clear" title="Edit" (click)="setEditMode()" authenticate-user="position.update"><i class="fa fa-pencil"></i></button>
              </p>
            </div>
            <form *ngIf="editMode" class="form-inline pull-left" #f="ngForm" name="updateTemplateForm" novalidate>
              <div class="form-group">
                <input type="text" appInputRestriction="restrictChars" [(ngModel)]="name" class="form-control"
                       name="templateName" required maxlength="100" /><!--ng-value="{{name}}"-->
                <!--Need to make note check the validation 17 Nov2022-->
                <!--<span *ngIf="updateTemplateForm.template.$error.required && submitted" class="control-label control-label-error" style="color:red">Please enter a template name.</span>-->
                <span *ngIf="showErrormsg" class="control-label control-label-error" style="color:red">{{errorMsg}}</span>
              </div>&nbsp;
              <div class="form-group">
                <div class="btn-group">
                  <button type="button" class="btn btn-white" [ngClass]="{'btn-success':activeStatus, 'btn-white':!activeStatus}"
                          [(ngModel)]="activeStatus" ngDefaultControl name="activeStatus" (click)="activeStatus = true;" btn-radio="true">
                    Active
                  </button>
                  <button type="button" class="btn btn-white" [ngClass]="{'btn-white':activeStatus, 'btn-danger':!activeStatus}"
                          [(ngModel)]="activeStatus" ngDefaultControl name="activeStatus" (click)="activeStatus = false;" btn-radio="false">
                    Inactive
                  </button>
                </div>

              </div>
              <button type="button" class="btn btn-white" [disabled]="isCloneInProgress" title="Save" (click)="saveTemplate(f.valid)"><i class="fa fa-save" style="color:orange"></i></button>
              <button type="button" class="btn btn-white" title="Cancel" (click)="setReadMode()"><i class="fa fa-ban"></i></button>

            </form>
            <button type="button" class="btn btn-primary pull-right talent-payroll-btncls" (click)="addTemplateDetail()" [disabled]="disableAddButton" authenticate-user="position.create">+ Add Timecard</button>
          </div>
          <div class="header-bar clearfix">
            <div class="row view-options" *ngIf="queryContainer_template.query.totalRecords > 0">
              <div class="col-md-12">
                <div class="col-md-7 float-start">
                  <div class="form-inline form-sort-options">
                    <div class="form-group">
                      <nbc-page-size [source]='pageSize'
                                     [model]="queryContainer_template.query.pageSize"
                                     (nbcValueChange)="searchPage($event)">
                    </nbc-page-size>
                    </div>
                  </div>
                </div>
                    <div class="col-md-5 float-end">
                      <div class="form-group pagination-container d-flex" style="margin-bottom:0">
                        <label class="pagination-results ms-auto">
                          <pagination-label pageSize="{{queryContainer_template.query.pageSize}}"
                                            currentPage="{{queryContainer_template.query.currentPage}}"
                                            totalRecords="{{queryContainer_template.query.totalRecords}}"></pagination-label>
                        </label>
                        <nbc-pagination totalItems="{{queryContainer_template.query.totalRecords}}"
                                        itemsPerPage="{{queryContainer_template.query.pageSize}}"
                                        [currentPage]="queryContainer_template.query.currentPage"
                                        (pageChanged)="templateSearch($event)"></nbc-pagination>
                      </div>
                    </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!--@section scripts
{

<script type="text/javascript">
  (function () {
    var templateId = @Html.Json(this.Model);
    window.preload["templateId"] = templateId;
  }());

</script>

<script src="~/Scripts/app/TalentPayroll/services/talentPayrollServices.js?v=@AssemblyHelper.versionHash"></script>
}-->
